import errorPage from '../assets/images/errorPage.png';
import { useNavigate } from 'react-router-dom';

export default function ErrorPage() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/', { replace: true });
    setTimeout(() => {
      window.location.reload();
    }, 10);
  };

  return (
    <div
      className="h-screen flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${errorPage})` }}
    >
      <h1 className="text-h2 font-bold mb-4">Oops!</h1>

      <p className="mb-6 text-p3 text-gray-400 text-center">
        Sorry. Page not found.
        <br />
        The page you were looking for appears to have been moved,
        <br />
        deleted or does not exist.
      </p>
      <button
        onClick={handleGoHome}
        className="px-6 py-3 bg-primary text-white text-lg rounded-lg hover:bg-primary-700 transition"
      >
        Go Home
      </button>
    </div>
  );
}
